// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/concurso/concurso.css
// module id = 245
// module chunks = 0